export enum EContractActions {
  ADMIN_ESCALATE_ITEM_FOR_PROVIDER = "ADMIN_ESCALATE_ITEM_FOR_PROVIDER",
  ADMIN_ESCALATE_DELIVERY_FOR_PROVIDER = "ADMIN_ESCALATE_DELIVERY_FOR_PROVIDER",
  ADMIN_ESCALATE_DELIVERY_FOR_CUSTOMER = "ADMIN_ESCALATE_DELIVERY_FOR_CUSTOMER",
  ADMIN_ESCALATE_ITEM_FOR_CUSTOMER = "ADMIN_ESCALATE_ITEM_FOR_CUSTOMER",
  ADMIN_RESOLVE_ESCALATION = "ADMIN_RESOLVE_ESCALATION",
  ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER = "ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER",
  ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER = "ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER",
  ADMIN_ACCEPT_ITEM = "ADMIN_ACCEPT_ITEM",
  ADMIN_DELETE_CONTRACT = "ADMIN_DELETE_CONTRACT",
  ADMIN_CHANGE_DELIVERY_PERIOD = "ADMIN_CHANGE_DELIVERY_PERIOD",
  ADMIN_CHANGE_INSPECTION_PERIOD = "ADMIN_CHANGE_INSPECTION_PERIOD",
  CUSTOMER_DENY_DELIVERY = "CUSTOMER_DENY_DELIVERY",
  ADMIN_DENY_PAYMENT = "ADMIN_DENY_PAYMENT",
  CUSTOMER_FUND = "CUSTOMER_FUND",
  CASH_OUT = "CASH_OUT",
  ADMIN_SETTLE_TRANSACTION = "ADMIN_SETTLE_TRANSACTION",
  PROVIDER_CHECK_ESCALATION = "PROVIDER_CHECK_ESCALATION",
  CUSTOMER_CONFIRM_DELIVERY = "CUSTOMER_CONFIRM_DELIVERY",
  CUSTOMER_ACCEPT_ITEM = "CUSTOMER_ACCEPT_ITEM",
  CUSTOMER_REJECT_ITEM = "CUSTOMER_REJECT_ITEM",
  ADMIN_CONFIRM_DELIVERY = "ADMIN_CONFIRM_DELIVERY",
  ADMIN_REFUND_CUSTOMER = "ADMIN_REFUND_CUSTOMER",
  ADMIN_RELEASE_FUND_TO_SELLER = "ADMIN_RELEASE_FUND_TO_SELLER",
  CUSTOMER_CHECK_ESCALATION = "CUSTOMER_CHECK_ESCALATION",
  PROVIDER_ESCALATE_DELIVERY = "PROVIDER_ESCALATE_DELIVERY",
  PROVIDER_ESCALATE_ITEM = "PROVIDER_ESCALATE_ITEM",
  PROVIDER_CANCEL_CONTRACT = "PROVIDER_CANCEL_CONTRACT",
  CUSTOMER_CHANGE_REQUESTED = "CUSTOMER_CHANGE_REQUESTED",
  SELLER_APPROVE_CONTRACT = "SELLER_APPROVE_CONTRACT",
  SELLER_REJECT_CONTRACT = "SELLER_REJECT_CONTRACT",
  CUSTOMER_REQUEST_PAYMENT_VERIFICATION = "CUSTOMER_REQUEST_PAYMENT_VERIFICATION",
  ADMIN_DELETE_ITEM = "ADMIN_DELETE_ITEM",
  BROKER_CREATE_CONTRACT = "BROKER_CREATE_CONTRACT",
  RECEIVER_ACCEPT_CONTRACT = "RECEIVER_ACCEPT_CONTRACT",
  BROKER_REFUND_CUSTOMER = "BROKER_REFUND_CUSTOMER",
  BROKER_ACCEPT_ITEM = "BROKER_ACCEPT_ITEM",
  ADMIN_VERIFY_PAYMENT = "ADMIN_VERIFY_PAYMENT",
  ARBITRATOR_CONFIRM_DELIVERY = "ARBITRATOR_CONFIRM_DELIVERY",
  ARBITRATOR_ACCEPT_ITEM = "ARBITRATOR_ACCEPT_ITEM",
  ARBITRATOR_RESOLVE_REFUND_CUSTOMER = "ARBITRATOR_RESOLVE_REFUND_CUSTOMER",
  ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER = "ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER",
  ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER = "ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER",
  ADMIN_CLOSE_REFUND_CUSTOMER = "ADMIN_CLOSE_REFUND_CUSTOMER",
  ADMIN_SETTLE_CONTRACT = "ADMIN_SETTLE_CONTRACT",
  ACCEPT_CONTRACT = "ACCEPT_CONTRACT",
  REJECT_CONTRACT = "REJECT_CONTRACT",
  SETTLE_CONTRACT = "SETTLE_CONTRACT",
  ACCEPT_ITEM = "ACCEPT_ITEM",
  ADMIN_REDRAFT_SETTLEMENT_CONTRACT = "ADMIN_REDRAFT_SETTLEMENT_CONTRACT",
  ADMIN_TO_WAITING_FOR_DELIVERY = "ADMIN_TO_WAITING_FOR_DELIVERY",
  ADMIN_ACCEPT_SUGGESTED_SETTLEMENT = "ADMIN_ACCEPT_SUGGESTED_SETTLEMENT",
}
